import http from '@/http/aisea/axios'
const resource = '/account/admin/login'

export default {
  loginWithEnterprise (payload, headers) {
    //Repository.defaults.headers.post['Content-Type'] = 'multipart/form-data'
    return http.post(`${resource}/enterprise`, payload, {
      headers: headers
    })
  },
  loginMarina (payload, headers) {
    //Repository.defaults.headers.post['Content-Type'] = 'multipart/form-data'
    return http.post(`${resource}/marina`, payload, {
      headers: headers
    })
  },
  loginPersonal (payload, headers) {
    //Repository.defaults.headers.post['Content-Type'] = 'multipart/form-data'
    return http.post(`${resource}/personal`, payload, {
      headers: headers
    })
  },
  loginProject (payload, headers) {
    return http.post(`${resource}/project`, payload, {
      headers: headers
    })
  },
  logout() {
    return http.delete(`/account/admin/logout`)
  }
}
